import { Colors } from "~/jsx/theme";

export const XHistoryEvent = ({
  content,
}: {
  content: React.ReactNode | null;
}) => {
  if (content === null) return null;
  return (
    <div
      style={{
        boxShadow: "4px 4px 4px rgba(0, 0, 0, 0.25)",
        borderRadius: 12,
        backgroundColor: Colors.grey.e3,
        border: "solid 1px black",
      }}
    >
      {content}
    </div>
  );
};
